// CompanyVehicle (fleet) Action Types

// List
export const LIST_COMPANY_VEHICLES = "LIST_COMPANY_VEHICLES";
export const LIST_COMPANY_VEHICLES_SUCCESS = "LIST_COMPANY_VEHICLES_SUCCESS";
export const LIST_COMPANY_VEHICLES_FAILURE = "LIST_COMPANY_VEHICLES_FAILURE";

// Create
export const CREATE_COMPANY_VEHICLE = "CREATE_COMPANY_VEHICLE";
export const CREATE_COMPANY_VEHICLE_SUCCESS = "CREATE_COMPANY_VEHICLE_SUCCESS";
export const CREATE_COMPANY_VEHICLE_FAILURE = "CREATE_COMPANY_VEHICLE_FAILURE";

// Update
export const UPDATE_COMPANY_VEHICLE = "UPDATE_COMPANY_VEHICLE";
export const UPDATE_COMPANY_VEHICLE_SUCCESS = "UPDATE_COMPANY_VEHICLE_SUCCESS";
export const UPDATE_COMPANY_VEHICLE_FAILURE = "UPDATE_COMPANY_VEHICLE_FAILURE";

// Delete
export const DELETE_COMPANY_VEHICLE = "DELETE_COMPANY_VEHICLE";
export const DELETE_COMPANY_VEHICLE_SUCCESS = "DELETE_COMPANY_VEHICLE_SUCCESS";
export const DELETE_COMPANY_VEHICLE_FAILURE = "DELETE_COMPANY_VEHICLE_FAILURE";

// Single CompanyVehicle details
export const GET_COMPANY_VEHICLE_DETAILS = "GET_COMPANY_VEHICLE_DETAILS";
export const GET_COMPANY_VEHICLE_DETAILS_SUCCESS =
  "GET_COMPANY_VEHICLE_DETAILS_SUCCESS";
export const GET_COMPANY_VEHICLE_DETAILS_FAILURE =
  "GET_COMPANY_VEHICLE_DETAILS_FAILURE";

//companyvehicle/search
export const COMPANY_VEHICLE_SEARCH = "COMPANY_VEHICLE_SEARCH";
export const COMPANY_VEHICLE_SEARCH_SUCCESS = "COMPANY_VEHICLE_SEARCH_SUCCESS";
export const COMPANY_VEHICLE_SEARCH_FAILURE = "COMPANY_VEHICLE_SEARCH_FAILURE";

// CompanyVehicleStatus CRUD
export const COMPANY_VEHICLE_STATUS_LIST = "COMPANY_VEHICLE_STATUS_LIST";
export const COMPANY_VEHICLE_STATUS_LIST_SUCCESS =
  "COMPANY_VEHICLE_STATUS_LIST_SUCCESS";
export const COMPANY_VEHICLE_STATUS_LIST_FAILURE =
  "COMPANY_VEHICLE_STATUS_LIST_FAILURE";

export const COMPANY_VEHICLE_STATUS_CREATE = "COMPANY_VEHICLE_STATUS_CREATE";
export const COMPANY_VEHICLE_STATUS_CREATE_SUCCESS =
  "COMPANY_VEHICLE_STATUS_CREATE_SUCCESS";
export const COMPANY_VEHICLE_STATUS_CREATE_FAILURE =
  "COMPANY_VEHICLE_STATUS_CREATE_FAILURE";

export const COMPANY_VEHICLE_STATUS_UPDATE = "COMPANY_VEHICLE_STATUS_UPDATE";
export const COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_STATUS_UPDATE_FAILURE =
  "COMPANY_VEHICLE_STATUS_UPDATE_FAILURE";

export const COMPANY_VEHICLE_STATUS_DELETE = "COMPANY_VEHICLE_STATUS_DELETE";
export const COMPANY_VEHICLE_STATUS_DELETE_SUCCESS =
  "COMPANY_VEHICLE_STATUS_DELETE_SUCCESS";
export const COMPANY_VEHICLE_STATUS_DELETE_FAILURE =
  "COMPANY_VEHICLE_STATUS_DELETE_FAILURE";

// CompanyVehicleType CRUD
export const COMPANY_VEHICLE_TYPE_LIST = "COMPANY_VEHICLE_TYPE_LIST";
export const COMPANY_VEHICLE_TYPE_LIST_SUCCESS =
  "COMPANY_VEHICLE_TYPE_LIST_SUCCESS";
export const COMPANY_VEHICLE_TYPE_LIST_FAILURE =
  "COMPANY_VEHICLE_TYPE_LIST_FAILURE";

export const COMPANY_VEHICLE_TYPE_CREATE = "COMPANY_VEHICLE_TYPE_CREATE";
export const COMPANY_VEHICLE_TYPE_CREATE_SUCCESS =
  "COMPANY_VEHICLE_TYPE_CREATE_SUCCESS";
export const COMPANY_VEHICLE_TYPE_CREATE_FAILURE =
  "COMPANY_VEHICLE_TYPE_CREATE_FAILURE";

export const COMPANY_VEHICLE_TYPE_UPDATE = "COMPANY_VEHICLE_TYPE_UPDATE";
export const COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_TYPE_UPDATE_FAILURE =
  "COMPANY_VEHICLE_TYPE_UPDATE_FAILURE";

export const COMPANY_VEHICLE_TYPE_DELETE = "COMPANY_VEHICLE_TYPE_DELETE";
export const COMPANY_VEHICLE_TYPE_DELETE_SUCCESS =
  "COMPANY_VEHICLE_TYPE_DELETE_SUCCESS";
export const COMPANY_VEHICLE_TYPE_DELETE_FAILURE =
  "COMPANY_VEHICLE_TYPE_DELETE_FAILURE";

// CompanyVehicleCheckType CRUD
export const COMPANY_VEHICLE_CHECK_TYPE_LIST =
  "COMPANY_VEHICLE_CHECK_TYPE_LIST";
export const COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS =
  "COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS";
export const COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE =
  "COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE";

export const COMPANY_VEHICLE_CHECK_TYPE_CREATE =
  "COMPANY_VEHICLE_CHECK_TYPE_CREATE";
export const COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE =
  "COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE";

export const COMPANY_VEHICLE_CHECK_TYPE_UPDATE =
  "COMPANY_VEHICLE_CHECK_TYPE_UPDATE";
export const COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE =
  "COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE";

export const COMPANY_VEHICLE_CHECK_TYPE_DELETE =
  "COMPANY_VEHICLE_CHECK_TYPE_DELETE";
export const COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE =
  "COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE";

// CompanyVehicleCheck CRUD (scoped by vehicle)
export const COMPANY_VEHICLE_CHECK_LIST = "COMPANY_VEHICLE_CHECK_LIST";
export const COMPANY_VEHICLE_CHECK_LIST_SUCCESS =
  "COMPANY_VEHICLE_CHECK_LIST_SUCCESS";
export const COMPANY_VEHICLE_CHECK_LIST_FAILURE =
  "COMPANY_VEHICLE_CHECK_LIST_FAILURE";

export const COMPANY_VEHICLE_CHECK_CREATE = "COMPANY_VEHICLE_CHECK_CREATE";
export const COMPANY_VEHICLE_CHECK_CREATE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_CREATE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_CREATE_FAILURE =
  "COMPANY_VEHICLE_CHECK_CREATE_FAILURE";

export const COMPANY_VEHICLE_CHECK_UPDATE = "COMPANY_VEHICLE_CHECK_UPDATE";
export const COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_UPDATE_FAILURE =
  "COMPANY_VEHICLE_CHECK_UPDATE_FAILURE";

export const COMPANY_VEHICLE_CHECK_DELETE = "COMPANY_VEHICLE_CHECK_DELETE";
export const COMPANY_VEHICLE_CHECK_DELETE_SUCCESS =
  "COMPANY_VEHICLE_CHECK_DELETE_SUCCESS";
export const COMPANY_VEHICLE_CHECK_DELETE_FAILURE =
  "COMPANY_VEHICLE_CHECK_DELETE_FAILURE";

// CompanyVehicleToStaff CRUD (assignment / custody log)
export const COMPANY_VEHICLE_TO_STAFF_LIST = "COMPANY_VEHICLE_TO_STAFF_LIST";
export const COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS =
  "COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS";
export const COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE =
  "COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE";

export const COMPANY_VEHICLE_TO_STAFF_CREATE =
  "COMPANY_VEHICLE_TO_STAFF_CREATE";
export const COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS =
  "COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS";
export const COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE =
  "COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE";

export const COMPANY_VEHICLE_TO_STAFF_UPDATE =
  "COMPANY_VEHICLE_TO_STAFF_UPDATE";
export const COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE =
  "COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE";

export const COMPANY_VEHICLE_TO_STAFF_DELETE =
  "COMPANY_VEHICLE_TO_STAFF_DELETE";
export const COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS =
  "COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS";
export const COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE =
  "COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE";

export const COMPANY_VEHICLE_TO_STAFF_SEARCH =
  "COMPANY_VEHICLE_TO_STAFF_SEARCH";
export const COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS =
  "COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS";
export const COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE =
  "COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE";

// Pool-car checkout / checkin (single flat object bodies)
export const COMPANY_VEHICLE_CHECKOUT = "COMPANY_VEHICLE_CHECKOUT";
export const COMPANY_VEHICLE_CHECKOUT_SUCCESS =
  "COMPANY_VEHICLE_CHECKOUT_SUCCESS";
export const COMPANY_VEHICLE_CHECKOUT_FAILURE =
  "COMPANY_VEHICLE_CHECKOUT_FAILURE";

export const COMPANY_VEHICLE_CHECKIN = "COMPANY_VEHICLE_CHECKIN";
export const COMPANY_VEHICLE_CHECKIN_SUCCESS =
  "COMPANY_VEHICLE_CHECKIN_SUCCESS";
export const COMPANY_VEHICLE_CHECKIN_FAILURE =
  "COMPANY_VEHICLE_CHECKIN_FAILURE";

// CompanyVehicleNote CRUD (scoped by vehicle)
export const COMPANY_VEHICLE_NOTE_LIST = "COMPANY_VEHICLE_NOTE_LIST";
export const COMPANY_VEHICLE_NOTE_LIST_SUCCESS =
  "COMPANY_VEHICLE_NOTE_LIST_SUCCESS";
export const COMPANY_VEHICLE_NOTE_LIST_FAILURE =
  "COMPANY_VEHICLE_NOTE_LIST_FAILURE";

export const COMPANY_VEHICLE_NOTE_CREATE = "COMPANY_VEHICLE_NOTE_CREATE";
export const COMPANY_VEHICLE_NOTE_CREATE_SUCCESS =
  "COMPANY_VEHICLE_NOTE_CREATE_SUCCESS";
export const COMPANY_VEHICLE_NOTE_CREATE_FAILURE =
  "COMPANY_VEHICLE_NOTE_CREATE_FAILURE";

export const COMPANY_VEHICLE_NOTE_UPDATE = "COMPANY_VEHICLE_NOTE_UPDATE";
export const COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_NOTE_UPDATE_FAILURE =
  "COMPANY_VEHICLE_NOTE_UPDATE_FAILURE";

export const COMPANY_VEHICLE_NOTE_DELETE = "COMPANY_VEHICLE_NOTE_DELETE";
export const COMPANY_VEHICLE_NOTE_DELETE_SUCCESS =
  "COMPANY_VEHICLE_NOTE_DELETE_SUCCESS";
export const COMPANY_VEHICLE_NOTE_DELETE_FAILURE =
  "COMPANY_VEHICLE_NOTE_DELETE_FAILURE";

//companyvehiclerecentactivity/list
export const COMPANY_VEHICLE_RECENT_ACTIVITY_LIST =
  "COMPANY_VEHICLE_RECENT_ACTIVITY_LIST";
export const COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS =
  "COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS";
export const COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE =
  "COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE";

// CompanyVehicleGpsTracker (scoped by vehicle)
export const COMPANY_VEHICLE_GPS_TRACKER_LIST =
  "COMPANY_VEHICLE_GPS_TRACKER_LIST";
export const COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE";

export const COMPANY_VEHICLE_GPS_TRACKER_CREATE =
  "COMPANY_VEHICLE_GPS_TRACKER_CREATE";
export const COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE";

export const COMPANY_VEHICLE_GPS_TRACKER_UPDATE =
  "COMPANY_VEHICLE_GPS_TRACKER_UPDATE";
export const COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE";

export const COMPANY_VEHICLE_GPS_TRACKER_DELETE =
  "COMPANY_VEHICLE_GPS_TRACKER_DELETE";
export const COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE";

// GPSLive provider device picker
export const COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES =
  "COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES";
export const COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE";

// Refresh a tracker's live position from the provider
export const COMPANY_VEHICLE_GPS_TRACKER_REFRESH =
  "COMPANY_VEHICLE_GPS_TRACKER_REFRESH";
export const COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS =
  "COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS";
export const COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE =
  "COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE";

// CompanyVehicleAttachment (scoped by vehicle)
export const COMPANY_VEHICLE_ATTACHMENT_SEARCH =
  "COMPANY_VEHICLE_ATTACHMENT_SEARCH";
export const COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS =
  "COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS";
export const COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE =
  "COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE";

export const COMPANY_VEHICLE_ATTACHMENT_DELETE =
  "COMPANY_VEHICLE_ATTACHMENT_DELETE";
export const COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS =
  "COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS";
export const COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE =
  "COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE";
